import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import instance from "../../config/axios";
import moment from "moment";
import "moment/locale/id";
import "./DetailYoutube.css";
import Box from "@mui/material/Box";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const DetailYoutube = () => {
  const [detail, setDetail] = useState([]);
  const { tv } = useParams();
  let c = new Date();
  c.setHours(0);
  c.setMinutes(0);
  c.setSeconds(0);
  const start_date = moment(c).format("YYYY-MM-DD HH:mm:ss");
  const end_date = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

  const options = {
    chart: {
      style: {
        borderRadius: "10px",
      },
      // backgroundColor: "rgba(255,255,255, 0.05)",
    },
    // legend: {
    //   itemStyle: {
    //     color: "#ffffff",
    //   },
    // },
    accessibility: {
      enabled: false,
    },
    title: {
      text: "Youtube.com",
      // style: {
      //   color: "#ffffff",
      // },
    },
    xAxis: {
      type: "datetime",
      //   labels: {
      //     style: {
      //       color: "#ffffff",
      //     },
      //   },
    },
    // yAxis: {
    //   labels: {
    //     style: {
    //       color: "#ffffff",
    //     },
    //   },
    // },
    series: [
      {
        type: "line",
        name: "youtube.com",
        data: detail,
      },
    ],
  };

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await instance.post("/tv/detail/youtube", {
          stasion_name: tv,
          start_date,
          end_date,
        });
        setDetail(res.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchDetail();
  }, [tv, start_date, end_date]);

  return (
    <>
      {detail && (
        <div className="detail-container">
          <div className="detail-title-container">
            <img src="/assets/logo-youtube.png" alt="" width="150px" />
          </div>
          <div className="chart-container">
            <div className="chart-title">
              <h2>{tv}</h2>
            </div>
            <Box sx={{ m: 2 }}>
              <HighchartsReact highcharts={Highcharts} options={options} />
            </Box>
          </div>
        </div>
      )}
    </>
  );
};

export default DetailYoutube;
